import type { GetAllFeatureFlags } from '@/model/feature-flag'
import { wsClient } from '@/plugins/axios'

export const featureFlagsRepository = {
  async all() {
    const { data } = await wsClient.get<GetAllFeatureFlags>('/feature-flags')
    return data.featureFlags
  },
}
